import type { MouseEventHandler } from "react";

import Button from "@/design-system/button";
import { FetchPost } from "@/lib/fetch-helper";
import { languageSelector } from "@/src/contexts";
import { browserStatics } from "@/src/shared/BrowserStatic";
import * as stylex from "@stylexjs/stylex";

import { type PropsWithStyleX, colors } from "../../../styles/tokens.stylex";
import ukFlag from "./flag-en.svg";
import plFlag from "./flag-pl.svg";

const styles = stylex.create({
    button: {
        alignItems: "center",
        color: colors.fg_Accent,
        display: "flex",
    },
    flag: {
        height: "1em",
        marginRight: "0.3125rem",
    },
});

export type ILanguageSwitcher = PropsWithStyleX;

export default function LanguageSwitcher({ styleX: style }: ILanguageSwitcher) {
    const language = languageSelector("English", "Polski");

    const onClick: MouseEventHandler<HTMLButtonElement> = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        FetchPost("/api/language/switch").then(() => {
            window.location.reload();
        });

        return false;
    };

    return (
        <Button
            as="button"
            type="submit"
            variant="none"
            size="M"
            onClick={onClick}
            styleX={[styles.button, style]}
            icon={
                <img
                    {...stylex.props(styles.flag)}
                    src={browserStatics.culture === "pl-PL" ? ukFlag : plFlag}
                    alt={language}
                />
            }
        >
            {language}
        </Button>
    );
}
